module.exports = __webpack_public_path__ + "img/wachlarz.9aac8872.jpg";